import { z } from "zod";

export const ManagementGroupAdminSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    addedAt: z.string(),
});

export type ManagementGroupAdmin = z.infer<typeof ManagementGroupAdminSchema>;

export const WorkflowOwnershipScopeSchema = z.object({
    kind: z.string(),
    entityType: z.string().nullable().optional(),
});

export type WorkflowOwnershipScope = z.infer<typeof WorkflowOwnershipScopeSchema>;

export const TeamMemberSchema = z.object({
    userId: z.string(),
    displayName: z.string(),
    addedAt: z.string(),
});

export type TeamMember = z.infer<typeof TeamMemberSchema>;

export const TeamSchema = z.object({
    id: z.string(),
    name: z.string(),
    createdAt: z.string(),
    createdBy: z.string(),
    members: z.array(TeamMemberSchema),
});

export type Team = z.infer<typeof TeamSchema>;

export const ManagementGroupSchema = z.object({
    id: z.string(),
    name: z.string(),
    isSystem: z.boolean(),
    createdAt: z.string(),
    createdBy: z.string(),
    deletedAt: z.string().nullable().optional(),
    admins: z.array(ManagementGroupAdminSchema),
    ownedWorkflowScopes: z.array(WorkflowOwnershipScopeSchema),
    teams: z.array(TeamSchema),
});

export type ManagementGroup = z.infer<typeof ManagementGroupSchema>;

export const ManagementGroupSummarySchema = z.object({
    id: z.string(),
    name: z.string(),
    isSystem: z.boolean(),
    adminCount: z.number(),
    ownedScopeCount: z.number(),
    activeTeamCount: z.number(),
    createdAt: z.string(),
    deletedAt: z.string().nullable().optional(),
});

export type ManagementGroupSummary = z.infer<typeof ManagementGroupSummarySchema>;

export const ManagementGroupListResponseSchema = z.object({
    items: z.array(ManagementGroupSummarySchema),
});

export type ManagementGroupListResponse = z.infer<typeof ManagementGroupListResponseSchema>;

export const TeamQueuePushResponseSchema = z.object({
    teamId: z.string(),
    queueId: z.string(),
    addedCount: z.number(),
    skippedAlreadyMemberCount: z.number(),
    addedUserIds: z.array(z.string()),
    skippedAlreadyMemberUserIds: z.array(z.string()),
});

export type TeamQueuePushResponse = z.infer<typeof TeamQueuePushResponseSchema>;

export const TeamQueueWithdrawResponseSchema = z.object({
    teamId: z.string(),
    queueId: z.string(),
    removedCount: z.number(),
    skippedNotMemberCount: z.number(),
    removedUserIds: z.array(z.string()),
    skippedNotMemberUserIds: z.array(z.string()),
});

export type TeamQueueWithdrawResponse = z.infer<typeof TeamQueueWithdrawResponseSchema>;
